import React, { Component } from 'react'
import _ from 'lodash'
import queryString from 'query-string'
import history from '../history'
import './styles.scss'
import { celsiusToFahrenheit, fahrenheitToCelsius, coversion, Settings } from '../../constants/common'

class EditTemperatureSettings extends Component {
  constructor() {
    super()
    this.temperature = Settings.MinMax()
    this.celsiusToFahrenheit = celsiusToFahrenheit
    this.fahrenheitToCelsius = fahrenheitToCelsius
    this.coversion = coversion
    this.state = {
      homeTemp: this.temperature.RED,
      sleepTemp: this.temperature.MIN,
      data: []
    }

    this.pressUpHome = this.pressUpHome.bind(this)
    this.pressDownHome = this.pressDownHome.bind(this)
    this.pressUpSleep = this.pressUpSleep.bind(this)
    this.pressDownSleep = this.pressDownSleep.bind(this)
    this.release = this.release.bind(this)
  }

  componentWillMount() {
    const { location, fetchRooms } = this.props
    const temp = queryString.parse(location.search)
    const home = temp.home
    const sleep = temp.sleep
    this.setState({ homeTemp: parseInt(home, 10), sleepTemp: parseInt(sleep, 10) })
    if (temp.roomId === 'all') { // Only fetch all rooms if user come from signup page
      fetchRooms()
    }
  }

  componentWillReceiveProps(np) {
    if (np.setTemperatures) {
      // Call setTemperature api and will always pass first element from the sliced data, till it gets empty
      const data = this.state.data
      data.splice(0, 1)
      this.setState({ data }, () => {
        if (data.length === 0) {
          // return back to privious page on api success
          history.goBack()
        } else {
          this.setTemperatureCall()
        }
      })
    }
  }

  homeTempUp() {
    // Increase count on home arrow click
    let { homeTemp } = this.state
    if (homeTemp <= this.temperature.MAX) {
      homeTemp = homeTemp + 1 > this.temperature.MAX ? this.temperature.MAX : homeTemp + 1
      this.setState({ homeTemp })
    } else {
      this.release()
    }
  }

  homeTempDown() {
    // Decrease count on home arrow click
    let { homeTemp } = this.state
    if (homeTemp >= this.temperature.MIN) {
      homeTemp = homeTemp - 1 < this.temperature.MIN ? this.temperature.MIN : homeTemp - 1
      this.setState({ homeTemp })
    } else {
      this.release()
    }
  }

  sleepTempUp() {
    // Increase count on sleep arrow click
    let { sleepTemp } = this.state
    if (sleepTemp <= this.temperature.MAX) {
      sleepTemp = sleepTemp + 1 > this.temperature.MAX ? this.temperature.MAX : sleepTemp + 1
      this.setState({ sleepTemp })
    } else {
      this.release()
    }
  }

  sleepTempDown() {
    // Decrease count on sleep arrow click
    let { sleepTemp } = this.state
    if (sleepTemp >= this.temperature.MIN) {
      sleepTemp = sleepTemp - 1 < this.temperature.MIN ? this.temperature.MIN : sleepTemp - 1
      this.setState({ sleepTemp })
    } else {
      this.release()
    }
  }

  pressUpHome() {
    // Increase counts on hold up home arrow
    this.buttonPressTimer = setInterval(() => {
      this.homeTempUp()
    }, 50)
  }

  pressDownHome() {
    // Decrease counts on hold down home arrow
    this.buttonPressTimer = setInterval(() => {
      this.homeTempDown()
    }, 50)
  }

  pressUpSleep() {
    // Increase counts on hold up sleep arrow
    this.buttonPressTimer = setInterval(() => {
      this.sleepTempUp()
    }, 50)
  }

  pressDownSleep() {
    // Decrease counts on hold down sleep arrow
    this.buttonPressTimer = setInterval(() => {
      this.sleepTempDown()
    }, 50)
  }

  release() {
    // Clear timers on unhold arrows
    clearTimeout(this.buttonPressTimer)
  }
  // Trigger API call to save temperature and 
  saveTemperature() {
    const { setTemperature, location, rooms } = this.props
    const temp = queryString.parse(location.search)
    if (
      this.state.homeTemp >= this.temperature.MIN &&
      this.state.homeTemp <= this.temperature.MAX &&
      this.state.sleepTemp >= this.temperature.MIN &&
      this.state.sleepTemp <= this.temperature.MAX
    ) {
      this.setState({ error: '' })
    
      let celsiusValueHome = this.state.homeTemp
      celsiusValueHome = celsiusValueHome === this.temperature.MAX ? this.temperature.CELSIUS_ADJUSTMENT_FOR_MAX : celsiusValueHome

      let celsiusValueSleep = this.state.sleepTemp
      celsiusValueSleep = celsiusValueSleep === this.temperature.MAX ? this.temperature.CELSIUS_ADJUSTMENT_FOR_MAX : celsiusValueSleep

      if (temp.roomId === 'all') {
        // When signup and first time user in
        const data = []
        _.forEach(rooms, (room, i) => {
          data.push({
            id: room.id,
            homeTemp: this.coversion() === 'F' ? this.fahrenheitToCelsius(this.state.homeTemp) : celsiusValueHome,
            sleepTemp: this.coversion() === 'F' ? this.fahrenheitToCelsius(this.state.sleepTemp) : celsiusValueSleep
          })
        })
        // set temperature to every day when user logs in first time to app
        this.setState({ data }, () => {
          this.setTemperatureCall()
        })
      } else {
        const data = {
          id: temp.roomId,
          homeTemp: this.coversion() === 'F' ? this.fahrenheitToCelsius(this.state.homeTemp) : celsiusValueHome,
          sleepTemp: this.coversion() === 'F' ? this.fahrenheitToCelsius(this.state.sleepTemp) : celsiusValueSleep
        }
        setTemperature(data)
      }
    } else {
      this.setState({ error: `Invalid temperatures value. Please try to set between ${this.temperature.MIN}° ${this.coversion()} to ${this.temperature.MAX} °${this.coversion()}.` })
    }
  }
  // API calls multiple time as applicable ie to come after signup and set for all room
  setTemperatureCall() {
    const { setTemperature } = this.props
    const data = _.first(this.state.data)
    setTemperature(data)
  }

  changeTemperature(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    const { homeTemp, sleepTemp } = this.state
    const textColor = parseFloat(homeTemp) < this.temperature.BLUE ? 'blue' : parseFloat(homeTemp) < this.temperature.ORANGE ? 'orange' : 'red'
    const textColorSleep = parseFloat(sleepTemp) < this.temperature.BLUE ? 'blue' : parseFloat(sleepTemp) < this.temperature.ORANGE ? 'orange' : 'red'
    return (
      <div
        onContextMenu={e => {
          e.preventDefault()
          return false
        }}
      >
        <main id="EditTemperatureSettings">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="secondary-title">Edit Temperature Settings</h3>
                    <div className="close">
                      <a onClick={() => history.goBack()}>
                        <img alt="" src="/img/close-icon.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="container-inner">
              <div className="col-md-12">
                 <small className="help-text"> Temperature settings will apply to every day in your calendar. 
                 You cannot set a different ‘Home’ or ‘Sleep’ temperature for different days of the week,
                 but you can change the times that these setting apply.</small>
              </div>
              <div className="center-box">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                        <img alt="" style={{ width: '36px' }} src="img/home_icon.svg" />
                        <h5>Home</h5>
                      </div>
                    </div>
                    <div className="temperature-box d-flex">
                      <img
                        alt=""
                        src="img/time_down_arrow.svg"
                        onTouchStart={this.pressDownHome}
                        onTouchEnd={this.release}
                        onMouseDown={this.pressDownHome}
                        onMouseUp={this.release}
                      />
                      <span className={textColor}>
                        <input
                          type="text"
                          name="homeTemp"
                          maxLength="2"
                          className={textColor}
                          value={homeTemp}
                          onChange={this.changeTemperature.bind(this)}
                        />
                        <small className={textColor}>°{this.coversion()}</small>
                      </span>
                      <img
                        alt=""
                        src="img/time_up_arrow.svg"
                        onTouchStart={this.pressUpHome}
                        onTouchEnd={this.release}
                        onMouseDown={this.pressUpHome}
                        onMouseUp={this.release}
                      />
                    </div>
                  </li>
                  <li className="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                        <img alt="" src="img/sleep_icon.png" />
                        <h5>Sleep</h5>
                      </div>
                    </div>
                    <div className="temperature-box d-flex">
                      <img
                        alt=""
                        src="img/time_down_arrow.svg"
                        onTouchStart={this.pressDownSleep}
                        onTouchEnd={this.release}
                        onMouseDown={this.pressDownSleep}
                        onMouseUp={this.release}
                      />
                      <span className={textColorSleep}>
                        <input
                          type="text"
                          name="sleepTemp"
                          maxLength="2"
                          className={textColorSleep}
                          value={sleepTemp}
                          onChange={this.changeTemperature.bind(this)}
                        />
                        <small className={textColorSleep}>°{this.coversion()}</small>
                      </span>
                      <img
                        alt=""
                        src="img/time_up_arrow.svg"
                        onTouchStart={this.pressUpSleep}
                        onTouchEnd={this.release}
                        onMouseDown={this.pressUpSleep}
                        onMouseUp={this.release}
                      />
                    </div>
                  </li>
                </ul>
                <footer>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <p>{this.state.error}</p>
                        <button type="button" className="btn btn-primary btn-lg btn-block" onClick={() => this.saveTemperature()}>
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}
export default EditTemperatureSettings



// WEBPACK FOOTER //
// ./src/views/EditTemperatureSettings/component.js